// extracted by mini-css-extract-plugin
export default {"wrapper":"Topics_wrapper__w4BPi","topic":"Topics_topic__R4aQh"};